/* eslint-disable max-lines */
import { COUNTRIES } from "../../constants/common/common";
import { InterceptorClient } from "../../interceptor/interceptorClient";
import { withServerCache } from "../../utils/cache-layer/serverCache";
import { execDataLayer } from "../../utils/cache-layer/cacheLayer";
import { endpointConst } from "../../utils/cache-layer/cacheLayerConstants";
import {
  CMS_API_VERSION,
  GET_DYNAMIC_SEARCH_TEXT_PLACEHOLDER,
  GET_CURRENCY_LIST,
  FUS_API,
  SUBSCRIBE_NEW_USER,
  GET_MEGA_MENU,
  GET_CALL_CHAT_TIME,
  GET_SAVED_ADDRESSES,
  GET_POPULAR_LINK404_DESKTOP,
  GET_POPULAR_LINK404_MOBILE,
  GET_MEGA_MENU_DESKTOP,
  GET_APP_CLEVERTAP_PUBLISH_URL,
  GET_GEOJS_URL,
  GET_CT_DISABLED_EVENT_LIST_URL,
  GET_ACCURACY_WEIGHTAGE_URL,
  GET_CURRENCY_FLAG_ICON,
  GET_AUTO_SUGGESTIONS,
  GET_SEARCH_SUGGESTIONS,
  GET_LOTTIE_ICONS,
  GET_FREE_DELIVERY_BANNER_URL,
  GET_SHOW_FREE_DELIVERY_FOR_PDP_URL,
  GET_REDIRECTION_OCCASION_NUDGE_DATA,
  CURRENCY_LIST_SERVER_CACHE_TTL_MS,
  CLEAR_CART_API,
  GET_IS_PARTNER_LINKED,
  PARTNER_LOYALTY_LINK_UPDATE,
  PARTNER_LOYALTY_CONTENT,
} from "./constant";

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
// const baseUrlApi = process.env.NEXT_PUBLIC_BASE_URL_API;

const basicHeaders = {
  "Access-Control-Allow-Credentials": "true",
  "Access-Control-Allow-Headers": "Content-Type",
  "Content-Type": "text/html;charset=UTF-8",
  "X-made-with": "Made with <3 in India",
};
/**
 * Method to fetch content from CMS on client side
 *
 * @param {string} contentURL page content slug
 * @returns {string} returns html file data
 */
export async function fetchContentFromCMSOnClient(contentURL, headersList, setResHeaders = false) {
  const headers = setResHeaders
    ? {
        ...basicHeaders,
        "edge-control": headersList?.["edge-control"],
        "edge-cache-tag": headersList?.["edge-cache-tag"],
        expires: headersList?.expires || headersList?.Expires,
      }
    : { ...basicHeaders };
  try {
    const endPoint = CMS_API_VERSION + contentURL;
    return await InterceptorClient.getGatewayInstance().get(endPoint, false, null, {
      ...headers,
    });
  } catch (err) {
    throw new Error(err.message);
  }
}

/** */
export async function fetchSearchSuggestions(geoId, keyword, uuid, userId) {
  try {
    return await InterceptorClient.getGatewayInstance().get(
      `${GET_SEARCH_SUGGESTIONS(geoId, keyword, uuid, userId)}`,
      false,
    );
  } catch (error) {
    throw new Error(error.message);
  }
}

/** */
export async function fetchSearchAutoSuggestions(geoId, keyword, pincode) {
  try {
    return await InterceptorClient.getGatewayInstance().get(`${GET_AUTO_SUGGESTIONS(geoId, keyword, pincode)}`, false);
  } catch (error) {
    throw new Error(error.message);
  }
}

/** */
export async function getCurrencyList() {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).get(
      `${GET_CURRENCY_LIST()}`,
      false,
      null,
      null,
      null,
      true,
    );
    if (response && !response?.status) {
      return response;
    } else {
      return {};
    }
  } catch (error) {
    console.log("Error in getCurrencyList:", error);
    return {};
  }
}

/**
 * Fetches currency list from the server.
 * @param {boolean} isMobile - Whether the request is for mobile or desktop.
 * @param {string} catalogId - The catalog ID.
 * @returns {Promise<Object>} A promise that resolves to the currency list.
 * @throws {Error} Throws an error if the API call fails or if an error occurs during the request.
 */
export async function getCurrencyListServer(isMobile, catalogId) {
  const cacheKey = `fnp:currency:${isMobile ? "m" : "d"}:${catalogId || COUNTRIES.INDIA}`;
  try {
    return await withServerCache(
      cacheKey,
      async () => {
        const response = await InterceptorClient.getFNTSInstance(baseUrl).get(
          `${GET_CURRENCY_LIST()}`,
          false,
          null,
          null,
          null,
          true,
        );
        if (response && !response?.status) {
          return response;
        } else {
          return {};
        }
      },
      CURRENCY_LIST_SERVER_CACHE_TTL_MS,
    );
  } catch (error) {
    console.log("Error in getCurrencyList:", error);
    return {};
  }
}
/**
 * get dynamic search placeholder
 *
 * @returns {Array} return the search text
 */
export async function getDynamicSearchTextPlaceholder() {
  try {
    const res = await InterceptorClient.getGatewayInstance().get(`${GET_DYNAMIC_SEARCH_TEXT_PLACEHOLDER()}`, false);
    return res;
  } catch (ex) {
    throw new Error({ ex, isSuccess: true });
  }
}

/**  Initiates a call to the FUS API using the InterceptorClient.
 *
 * This function retrieves data from the FUS API endpoint defined by `FUS_API`.
 * It utilizes the `InterceptorClient` to get the gateway instance and perform a GET request.
 *
 * @async
 * @function initiateFusCall
 * @returns {Promise<Object>} A promise that resolves to the response from the FUS API.
 * @throws {Error} Throws an error if the API call fails or if an error occurs during the request.
 *
 */
export async function initiateFusApiCall() {
  try {
    return await InterceptorClient.getGatewayInstance(baseUrl).get(`${FUS_API()}`, false);
  } catch (error) {
    throw new Error(error.message);
  }
}

/**
 * Initiates a call to the CLEAR CART API using the InterceptorClient.
 * @returns {Promise<Object>} A promise that resolves to the response from the CLEAR CART API.
 */
export async function initiateClearCartApiCall() {
  try {
    return await InterceptorClient.getGatewayInstance(baseUrl).post(null, `${CLEAR_CART_API()}`, false, {
      "x-api-version": "v1.4",
    });
  } catch (error) {
    throw new Error(error.message);
  }
}
/**
 * Fetches mega menu details from the API.
 * @returns {Promise<unknown>} A promise that resolves to the mega menu details.
 */
export const getMegaMenuContentAPI = async (isMobile, catalogID = "") => {
  return await InterceptorClient.getGatewayInstance().get(
    `${isMobile ? GET_MEGA_MENU(catalogID) : GET_MEGA_MENU_DESKTOP(catalogID)}`,
    false,
    null,
    {
      "x-device-type": isMobile ? "app" : "desktop",
      "x-domain": "www.fnp.com",
    },
  );
};

/**  Initiates a post call to the User Subscribing API using the InterceptorClient.
 *
 * This function retrieves data from the User Subscribing API endpoint defined by `SUBSCRIBE_NEW_USER`.
 * It utilizes the `InterceptorClient` to get the fnts instance and perform a POST request.
 *
 * @async
 * @function subscribeNewUser
 * @returns {Promise<Object>} A promise that resolves to the response from the User Subscribing API.
 * @throws {Error} Throws an error if the API call fails or if an error occurs during the request.
 */
export async function subscribeNewUser(params) {
  const urlParams = new URLSearchParams(params);
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).post(urlParams, `${SUBSCRIBE_NEW_USER()}`, false, {
      "Content-Type": "application/x-www-form-urlencoded",
    });
  } catch (error) {
    throw new Error(error.message);
  }
}

/**
 * This method fetches Timing for CALL and CHAT.
 *
 * @returns {object} response
 */
export async function getCallChatTime() {
  try {
    const response = await InterceptorClient.getGatewayInstance().get(`${GET_CALL_CHAT_TIME()}`, false);
    return response;
  } catch (ex) {
    return ex;
  }
}
/**
 * This method fetches Timing for CALL and CHAT.
 *
 * @returns {object} response
 */
export async function getSavedAddresses() {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_SAVED_ADDRESSES()}`, false);
    return response;
  } catch (ex) {
    return ex;
  }
}

/**
 * This method fetches popular link desktop data for OOPS 404 page.
 *
 * @returns {object} response
 */
export async function getPopularLink404Desktop() {
  try {
    const response = await InterceptorClient.getGatewayInstance().get(`${GET_POPULAR_LINK404_DESKTOP()}`, false);
    return response;
  } catch (ex) {
    return ex;
  }
}

/**
 * This method fetches popular link mobile data for OOPS 404 page.
 *
 * @returns {object} response
 */
export async function getPopularLink404Mobile() {
  try {
    const response = await InterceptorClient.getGatewayInstance().get(`${GET_POPULAR_LINK404_MOBILE()}`, false);
    return response;
  } catch (ex) {
    return ex;
  }
}

/**
 * Function to publish data to CleverTap
 * @param {Object} params - Parameters to be sent in the API request
 * @returns {Promise<Object|null>} - The API response data or null in case of error
 */
export const onClevertapPublish = async (params) => {
  try {
    const response = await InterceptorClient.getGatewayInstance().post(params, GET_APP_CLEVERTAP_PUBLISH_URL(), false);
    return response;
  } catch (err) {
    console.error("Error occurred while publishing to CleverTap:", err.message || "Something went wrong!");
  }
};

/**
 * Fetching geo location data.
 *
 * @returns {string} city name.
 */
export const fetchGeoLocation = async () => {
  try {
    const response = await fetch(GET_GEOJS_URL());
    if (!response.ok) {
      throw new Error(`Failed to fetch geolocation: ${response.status}`);
    }
    const geoData = await response;
    return geoData;
  } catch (error) {
    return error;
  }
};

/**
 * Fetching cleverTap disabled Events List
 *
 * @returns {string} city name.
 */
export const fetchCTDisabledEventList = async () => {
  try {
    const res = await InterceptorClient.getGatewayInstance().get(`${GET_CT_DISABLED_EVENT_LIST_URL()}`, false);
    return res;
  } catch (error) {
    console.error(
      "Error occurred while fetching to CleverTap disabled list:",
      error.message || "Something went wrong!",
    );
  }
};

/**
 * Fetches the Google place type accuracy weightage map.
 * Returns an empty object on failure so the cache layer does not store it.
 *
 * @returns {Promise<Object>} weightage map keyed by Google place type.
 */
export const fetchAccuracyWeightage = async () => {
  try {
    const res = await InterceptorClient.getGatewayInstance().get(`${GET_ACCURACY_WEIGHTAGE_URL()}`, false);
    return res?.responseStatus === 200 && res?.data ? res.data : {};
  } catch (error) {
    console.error("Error occurred while fetching accuracy weightage:", error.message || "Something went wrong!");
    return {};
  }
};

/**
 * Loads the accuracy weightage once per day through the cache layer (localStorage) on the client.
 * Waits for the browser to be idle (max 3s) so the call never competes with page rendering or other APIs.
 * Call it from a mount-only useEffect and return its result as the effect cleanup.
 *
 * @returns {Function} cleanup that cancels the scheduled call.
 */
export const loadAccuracyWeightageOnIdle = () => {
  if (typeof window === "undefined") return () => {};

  const idleTimeoutMs = 3000;
  /**
   * Reads today's cached weightage, calling the API only when the cache is missing or expired.
   * @returns {Promise<Object>} weightage map.
   */
  const loadAccuracyWeightage = () => execDataLayer(fetchAccuracyWeightage, endpointConst.accuracyWeightage);

  if ("requestIdleCallback" in window) {
    const idleId = window.requestIdleCallback(loadAccuracyWeightage, { timeout: idleTimeoutMs });
    return () => window.cancelIdleCallback(idleId);
  }

  // Safari fallback — no requestIdleCallback support
  const timeoutId = setTimeout(loadAccuracyWeightage, idleTimeoutMs);
  return () => clearTimeout(timeoutId);
};

/**
 * This method fetches currency with country flag an currency Icon.
 *
 * @returns {object} response
 */
export async function getCurrencyFlagIcon() {
  try {
    const response = await InterceptorClient.getGatewayInstance().get(`${GET_CURRENCY_FLAG_ICON()}`, false);
    return response;
  } catch (error) {
    console.error("Error getCurrencyFlagIcon:", error?.message);
  }
}

/**
 * get lottie icons
 *
 * @returns {Array} return the lottie icons
 */
export async function getLottieIcons() {
  try {
    const res = await InterceptorClient.getGatewayInstance().get(`${GET_LOTTIE_ICONS()}`, false);
    return res;
  } catch (ex) {
    throw new Error({ ex, isSuccess: true });
  }
}

/**
 * Fetches free delivery banner data from CMS.
 * @returns {Promise<Object>} A promise that resolves to the free delivery banner data.
 */
export const getFreeDeliveryBannerAPI = async () => {
  try {
    return await fetchContentFromCMSOnClient(GET_FREE_DELIVERY_BANNER_URL());
  } catch (error) {
    console.error("Error fetching free delivery banner:", error);
    return null;
  }
};

/**
 * Fetches show free delivery tag data from CMS.
 * @returns {Promise<Object>} A promise that resolves to the show free delivery tag data.
 */
export const getShowFreeDeliveryTagForPdpAPI = async () => {
  try {
    return await fetchContentFromCMSOnClient(GET_SHOW_FREE_DELIVERY_FOR_PDP_URL());
  } catch (error) {
    console.error("Error fetching free delivery tag flag:", error);
    return null;
  }
};

/**
 * Fetches show free delivery tag data from CMS.
 * @returns {Promise<Object>} A promise that resolves to the show free delivery tag data.
 */
export const redirectionoccasionnudge = async () => {
  try {
    return await fetchContentFromCMSOnClient(GET_REDIRECTION_OCCASION_NUDGE_DATA());
  } catch (error) {
    console.error("Error fetching free delivery tag flag:", error);
    return null;
  }
};

/**
 * Fetches whether the logged-in user has a partner loyalty account linked.
 * @returns {Promise<object|null>} Partner loyalty link payload, or null on failure.
 */
export async function getIsPartnerLinked(partnerId) {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_IS_PARTNER_LINKED(partnerId)}`, false);
    if (!response) {
      return null;
    }
    return response;
  } catch (error) {
    console.error("Error fetching partner loyalty link:", error);
    return null;
  }
}

/**
 * Links or unlinks a partner loyalty membership for the logged-in user.
 * @param {{ membershipId?: string, link: boolean }} payload
 * @returns {Promise<object|null>} Partner loyalty update payload, or null on failure.
 */
export async function updatePartnerLoyaltyLink(payload = {}) {
  try {
    const urlParams = new URLSearchParams();

    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        urlParams.append(key, String(value));
      }
    });

    const response = await InterceptorClient.getFNTSInstance(baseUrl).post(
      urlParams,
      `${PARTNER_LOYALTY_LINK_UPDATE()}`,
      false,
      {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    );
    return response || null;
  } catch (error) {
    console.error("Error updating partner loyalty link:", error);
    return null;
  }
}

/** */
export async function getPartnerContent() {
  try {
    const response = await InterceptorClient.getFNTSInstance(baseUrl).get(`${PARTNER_LOYALTY_CONTENT()}`, false);
    if (!response) {
      return null;
    }
    return response;
  } catch (error) {
    console.error("Error fetching partner loyalty content:", error);
    return null;
  }
}
